import apiClient from './client';

export interface Category {
  id: string;
  name: string;
  description?: string;
  parentCategory?: {
    _id: string;
    name: string;
  } | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCategoryRequest {
  name: string;
  description?: string;
  parentCategory?: string;
}

export interface UpdateCategoryRequest {
  name?: string;
  description?: string;
  parentCategory?: string | null;
  isActive?: boolean;
}

export const categoriesApi = {
  getAll: async (): Promise<Category[]> => {
    const response = await apiClient.get('/categories');
    return response.data.map((category: any) => ({
      ...category,
      id: category._id,
    }));
  },

  getById: async (id: string): Promise<Category> => {
    const response = await apiClient.get(`/categories/${id}`);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  getSubcategories: async (parentId: string): Promise<Category[]> => {
    const response = await apiClient.get(`/categories/${parentId}/subcategories`);
    return response.data.map((category: any) => ({
      ...category,
      id: category._id,
    }));
  },

  create: async (data: CreateCategoryRequest): Promise<Category> => {
    const response = await apiClient.post('/categories', data);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  update: async (id: string, data: UpdateCategoryRequest): Promise<Category> => {
    const response = await apiClient.put(`/categories/${id}`, data);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/categories/${id}`);
  },
};
